export default "__VITE_ASSET__ac1c3871__"